module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showName) { ;
__p += '\n<div class="effect-name">Opacity</div>\n';
 } ;
__p += '\n<div class="opacity-range-region"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/OpacityPropertiesView.tpl
// module id = 1744
// module chunks = 0